<template>
  <div class="matrix-gravity">
    <div :view="view" v-for="(item, index) in issue.items" :key="item.id">
      <div class="flex items-center">
        <div class="option-title" style="width: 140px">
          <div v-html="item.content.richText"></div>
        </div>
        <div class="option-slider flex-1 ml-5">
          <el-slider
            :value="item.value"
            show-input
            :max="issue.max"
            :min="issue.min"
            ref="elSlider"
            @input="onSliderChange($event, item, index)"
          />
        </div>
      </div>
    </div>
    <div class="text-right mt-2">
      比重总和：
      <span :class="{ 'text-red': isError }">
        <span>{{ currentValue }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatrixGravity',
  changeExpr: 'currentValue',
  computed: {
    isError() {
      return this.getCurrentValue() !== this.totalValue
    },
    totalValue() {
      return this.issue.totalValue
    },
    currentValue() {
      return this.getCurrentValue()
    }
  },

  methods: {
    getCurrentValue(exclusiveItem) {
      return this.issue.items.reduce((preValue, item) => {
        if (exclusiveItem && exclusiveItem.id === item.id) {
          return preValue + 0
        }
        return preValue + parseInt(item.value)
      }, 0)
    },
    onSliderChange(value, item, index) {
      item.value = value
      /* const items = this.issue.items
       if (items.length === 2) {
         if (items.every(item => item.value == '0') && value == '0') {
           // TODO
         } else {
           items.forEach(item => {
             item.value = this.issue.max - parseInt(value)
           })
         }
         item.value = value
       } else {
         let v = this.issue.totalValue - this.getCurrentValue(item)
         item.value = value
         this.$nextTick(() => {
           item.value = Math.min(v, value)
         })
       }*/
    }
  }
}
</script>
